import React, {useState, useEffect} from 'react';
import styled from 'styled-components';
import {BORDER, OzButton} from "@ozwol/webui";

const Wrapper = styled.div`
	position: relative;
	width: 30px;
	margin-top:1px;

	& button span{
		font-size: 20px;
		line-height: 24px;
	}

	overflow: visible;
	${props => props.isOpen ? "opacity: 1 !important;" : null}
	
`;
const List = styled.div`
	z-index: 999;
	position: absolute;
	top: 0px;
	right: 0px;
	display: inline-flex;
	flex-direction: column;
	background-color: #ffffff;

	border: 2px solid ${BORDER};
	width: 200px;
	box-shadow: rgba(104, 127, 226, 0.224) 0px 1px 2px;
	border-radius: 4px;

	& button span{
		font-size: 20px;
		line-height: 24px;
	}

	& button{
		border: 0px;
		background-color: transparent;
		border-radius: 0px;
		box-shadow: none;
		text-align: left;
		width: 100%;
		justify-content: flex-start;
		height: 32px;
	}
	& > *{
	}
	& > *:not(:last-child){
		border-bottom: 1px solid ${BORDER};
	}

	
`;


const Menu = ({list}) => {
  const [isOpen, setIsOpen] = useState(false);


	useEffect(() => {
    const onClick = (event) => setIsOpen(false);
      
		if(isOpen){
			setTimeout(() => {
				window.addEventListener('click', onClick);
			}, 100);
			
			return () => {
				window.removeEventListener('click', onClick);
			}
		}else{
			window.removeEventListener('click', onClick);
		}
  }, [isOpen]);

	return (
		<Wrapper isOpen={isOpen}>
			{list.filter(item => item !== null).length > 0 ? 
				<>
					<OzButton
						variant="push-black" 
						size="small" 
						width="30px"
						noMinWidth
						pushed={isOpen}
						onClick={() => setIsOpen(!isOpen)}
					><span className="material-symbols-outlined">more_vert</span></OzButton>
					{isOpen ? 
						<List>
							{list.filter(item => item !== null).map((item, i) =>
								<span key={i}>
									{item}
								</span>
							)}
						</List>
					: null}
				</>
			: null}
		</Wrapper>
  )
}

export default Menu;